import React from 'react'
import { Field, Fieldset, Label, Switch } from '@headlessui/react'
import { Fn } from 'depoto-core'

type Props = {
  label?: React.ReactNode;
  value?: boolean
  onChange?: Fn
  className?: string
}
export const Toggle: React.FC<Props> = ({ label, value, onChange, className }) => {
  return (
    <Fieldset>
      <Field>
        <div className="flex items-center gap-2">
          <Switch
            checked={!!value}
            onChange={() => (typeof onChange === 'function' ? onChange(!value) : null)}
            className={`${
              !!value ? 'bg-primary' : 'bg-gray-200'
            } relative inline-flex items-center h-6 rounded-full w-11 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2`}>
            <span
              className={`${
                !!value ? 'translate-x-6 bg-white' : 'translate-x-1 bg-gray-500'
              } inline-block w-4 h-4 transform rounded-full transition-transform`}
            />
          </Switch>
          {label && (
            <Label className={`font-semibold text-base cursor-pointer ${className}`}>{label}</Label>
          )}
        </div>
      </Field>
    </Fieldset>
  )
}
